import { render, staticRenderFns } from "./account-reauth.vue?vue&type=template&id=3f1b8b25&"
import script from "./account-reauth.vue?vue&type=script&lang=js&"
export * from "./account-reauth.vue?vue&type=script&lang=js&"
import style0 from "./account-reauth.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./account-reauth.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports